import SmartLink from '@/components/nav/links/SmartLink.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { App } from 'vue';
import AppContent from '@/components/AppContent.vue';
import AppFooter from '@/components/footer/AppFooter.vue';
import ClickoutAnchor from '@/components/nav/links/ClickoutAnchor.vue';

export const GlobalComponentsPlugin = {
	install(app: App) {
		app.component('FontAwesomeIcon', FontAwesomeIcon);
		// Register SmartLink globally so it can be used anywhere without importing
		app.component('SmartLink', SmartLink);
		app.component('AppFooter', AppFooter);
		app.component('AppContent', AppContent);
		app.component('ClickoutAnchor', ClickoutAnchor);
	},
};
